var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPictoRevenus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic-picto-revenus"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17C13.104 17 14 17.896 14 19C14 20.104 13.104 21 12 21C10.896 21 10 20.104 10 19C10 17.896 10.896 17 12 17Z",
    fill: "#86C56F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 21C5.8 21 6 21.2 6 21.5C6 21.8 5.8 22 5.5 22C5.2 22 5 21.8 5 21.5C5 21.2 5.2 21 5.5 21ZM5.5 16C5.8 16 6 16.2 6 16.5C6 16.8 5.8 17 5.5 17C5.2 17 5 16.8 5 16.5C5 16.2 5.2 16 5.5 16ZM12 16C13.7 16 15 17.3 15 19C15 20.7 13.7 22 12 22C10.3 22 9 20.7 9 19C9 17.3 10.3 16 12 16ZM18.5 21C18.8 21 19 21.2 19 21.5C19 21.8 18.8 22 18.5 22C18.2 22 18 21.8 18 21.5C18 21.2 18.2 21 18.5 21ZM18.5 16C18.8 16 19 16.2 19 16.5C19 16.8 18.8 17 18.5 17C18.2 17 18 16.8 18 16.5C18 16.2 18.2 16 18.5 16ZM4 23H20V15H4V23Z",
    fill: "#86C56F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 12C7.8 12 8 12.2 8 12.5C8 12.8 7.8 13 7.5 13C7.2 13 7 12.8 7 12.5C7 12.2 7.2 12 7.5 12ZM20.5 12C20.8 12 21 12.2 21 12.5C21 12.8 20.8 13 20.5 13C20.2 13 20 12.8 20 12.5C20 12.2 20.2 12 20.5 12ZM6 14H21V19H22V11H6V14Z",
    fill: "#639F4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 9C22.2 9 22 8.8 22 8.5C22 8.2 22.2 8 22.5 8C22.8 8 23 8.2 23 8.5C23 8.8 22.8 9 22.5 9ZM9.5 9C9.2 9 9 8.8 9 8.5C9 8.2 9.2 8 9.5 8C9.8 8 10 8.2 10 8.5C10 8.8 9.8 9 9.5 9ZM8 7V10H23V15H24V7H8Z",
    fill: "#120136"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPictoRevenus);
export default __webpack_public_path__ + "static/media/ic-picto-revenus.5ca3029e.svg";
export { ForwardRef as ReactComponent };